import { render, staticRenderFns } from "./ContractDataTab.vue?vue&type=template&id=de42b386&scoped=true"
import script from "./ContractDataTab.vue?vue&type=script&lang=js"
export * from "./ContractDataTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de42b386",
  null
  
)

export default component.exports